export interface IComparer<TValue> {
	(left: TValue, right: TValue): number;
}

export enum SortDirection {
	asc,
	desc
}

export function getStringComparer(direction: SortDirection): IComparer<string> {
	return direction === SortDirection.asc ? stringComparerAscending : stringComparerDescending;
}

export function stringComparerAscending(left: string, right: string): number {
	if (left === right) {
		return 0;
	}

	return left > right ? -1 : 1;
}

export function stringComparerDescending(left: string, right: string): number {
	return stringComparerAscending(left, right) * -1;
}
